module.exports = {"id":"225356","name":"Andrés Ibargüen","rating":"75","photo":"./data/images/photos/3/225356.png","club":{"name":"América","logo":"./data/images/clubs/America.png"},"positions":["AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresIbarguen0.json
// module id = 392
// module chunks = 0